import { Table } from "react-bootstrap";

export function TableRenderer({ headers, rows }) {
  const expected_columns = headers.length;
  let invalid_rows = [];
  for (let i = 0; i < rows.length; i++) {
    const row_length = rows[i].length;
    if (row_length !== expected_columns) {
      invalid_rows.push(
        {
          row_index: i,
          columns: row_length
        }
      );
    }
  }

  if (invalid_rows.length) {
    return (
      <div>
        Not all rows of the table match the expected number of columns.
        {invalid_rows.map((row) => {
          return (
            <div key={row.row_index}>
              Row {row.row_index} had {row.columns} element(s).
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          {headers.map((header, i) => {
            return (
              <th key={i}>
                {header}
              </th>
            )
          })}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, y) => {
          return (
            <tr key={y}>
              {row.map((cell, x) =>{
                return (
                  <td key={`${x}x${y}`}>
                    {cell}
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}
